import React from "react";
import { IconProps, getSocialIconColor } from "../SocialIcon";

export const Twitter: React.FC<IconProps> = (props) => {
  const fill = getSocialIconColor({
    ...props,
    colorFill: "#55acee"
  });

  return (
    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
      width="96px" height="80px" viewBox="0 0 96 80">
      <title>Twitter</title>
      <path id="Twitter-2" fill={fill} d="M93.3,1.5c-3.8,2.3-8.1,4-12.5,4.9C77.2,2.3,71.9,0,66.5,0c-11,0.2-19.8,9.2-19.7,20.2
        c0,1.5,0.2,3.1,0.5,4.6C31.4,23.9,16.6,16.2,6.7,3.7C4.9,6.8,4,10.3,4,13.9c0,6.7,3.2,13,8.8,16.8c-3.1-0.1-6.2-1-8.9-2.5v0.2
        c-0.1,9.5,6.5,17.8,15.8,19.8c-1.7,0.5-3.4,0.7-5.2,0.7c-1.2,0-2.5-0.1-3.7-0.4c2.5,8.1,9.9,13.8,18.4,14
        c-6.9,5.6-15.6,8.7-24.5,8.7c-1.6,0-3.1-0.1-4.7-0.3C9,76.8,19.5,80,30.2,80c36.2,0,56-30.8,56-57.5c0-0.9,0-1.8-0.1-2.6
        C90,17,93.3,13.5,96,9.5c-3.6,1.6-7.4,2.7-11.3,3.2C88.8,10.1,91.9,6.1,93.3,1.5z"/>
    </svg>
  )
}
